var cifPk = ["301 201", "<g fill='none'><path fill='#FFF' d='M.5.5h300v200H.5z'/><path fill='#01411C' d='M75.5.5h225v200h-225z'/><circle cx='188' cy='100.5' r='60' fill='#FFF'/><circle cx='203.337' cy='86.868' r='55' fill='#01411C'/><path fill='#FFF' d='M209.879 55.603l25.274 28.433-37.16-8.147 34.852-15.251-19.232 32.824z'/></g>"];

export { cifPk };

